/* XXX: this is a trick to handle hostnames like:
 *  - conseil.manomano(-dev)?.fr
 *  - advice.manomano(-dev).co.uk
 *
 * Using the regexp we catch the prefix (advice, conseil, ...)
 * and replace it with www. The trailing part of the name is kept.
 *
 * If the hostname is already www.manomano, the base menu URL remains empty.
 */
const hostPattern = /^(?<prefix>[^.]+)\.(?<suffix>((int|stg)\.)?manomano(-dev)?\.(.*))$/;

const allowedPrefixes = ["www", "pro"];

const getBaseUrl = (requestedHost) => {
  if (requestedHost === undefined) {
    return "";
  }

  const match = requestedHost.match(hostPattern);

  if (!match) {
    return "";
  }

  const { prefix, suffix } = match.groups;

  const isAllowedPrefix = allowedPrefixes.some((p) => prefix.endsWith(p));

  return isAllowedPrefix
    ? ""
    : `//${prefix.replace(/[^-]+$/, "www")}.${suffix}`;
};

export default getBaseUrl;
